module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/przebieg-5c901cae.png";